<template>
    <div class="row">
        <div class="col-12 mb-1">
            <div class="alert alert-danger mb-0">
                <div class="alert-body">
                    <strong>Değişiklik Türü :</strong> {{value.Reason}}
                    <template v-if="value.Type == 'KAMYON'"> (KAMYON)</template>
                    <template v-if="value.Type == 'TREYLER'"> (TIR/TREYLER)</template>
                    <template v-if="value.Type == 'KIRKAYAK'"> (KIRKAYAK)</template>
                </div>
            </div>
        </div>
        <div class="col-12 mb-1" v-if="value.ReasonCode == 'ROUTE_ERROR'">
            <h5 class="font-weight-bolder">Geçerli Rota</h5>
            <div class="table-responsive mb-0">
                <table class="table table-sm table-bordered">
                    <thead>
                        <tr>
                            <th></th>
                            <th colspan="3" class="text-center bg-light-primary">Başlangıç</th>
                            <th colspan="3" class="text-center bg-light-info">Bitiş</th>
                        </tr>
                        <tr>
                            <th>Durum</th>
                            <th>İl</th>
                            <th>İlçe</th>
                            <th>Mahalle</th>
                            <th>İl</th>
                            <th>İlçe</th>
                            <th>Mahalle</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr class="bg-light-success">
                            <td><strong>Geçerli</strong></td>
                            <td>{{value.Original.StartProvinceName || '-'}}</td>
                            <td>{{value.Original.StartDistrictName || '-'}}</td>
                            <td>{{value.Original.StartNeighbourhoodName || '-'}}</td>
                            <td>{{value.Original.EndProvinceName || '-'}}</td>
                            <td>{{value.Original.EndDistrictName || '-'}}</td>
                            <td>{{value.Original.EndNeighbourhoodName || '-'}}</td>
                        </tr>
                        <tr class="bg-light-warning">
                            <td><strong>Talep Edilen</strong></td>
                            <td>{{value.StartProvinceName || '-'}}</td>
                            <td>{{value.StartDistrictName || '-'}}</td>
                            <td>{{value.StartNeighbourhoodName || '-'}}</td>
                            <td>{{value.EndProvinceName || '-'}}</td>
                            <td>{{value.EndDistrictName || '-'}}</td>
                            <td>{{value.EndNeighbourhoodName || '-'}}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <div class="col-12" v-if="value.ReasonCode == 'CHANGE_PRICE'">
            <div class="table-responsive mb-0">
                <table class="table table-sm table-bordered">
                    <thead>
                        <tr>
                            <th>Durum</th>
                            <th>Tutar (TL)</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr class="bg-light-success">
                            <td><strong>Geçerli</strong></td>
                            <td>{{value.Original.PriceStr}}</td>
                        </tr>
                        <tr class="bg-light-warning">
                            <td><strong>Talep Edilen</strong></td>
                            <td>{{value.PriceStr}}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props:{
        value:Object
    }
}
</script>

<style>

</style>